import React,{useState,useEffect} from 'react'
import {Row, Col, Table} from 'antd'
import * as Home from '@/common/api/home'
function TableModal (props) {
    const [gzltjDetailTime, setGzltjDetailTime] = useState('近一月')
    const [dataQueryType, setDataQueryType] = useState(1)
    const [columns, setColumns] = useState([
        {
            title: '片区',
            dataIndex: 'area',
            align: 'center'
        },
        {
            title: '告警工单',
            dataIndex: 'alert',
            align: 'center',
            children: [
                {
                    title:'总计',
                    dataIndex: 'alertCount',
                    align: 'center'
                },
                {
                    title:'未受理',
                    dataIndex: 'alertUnprocessed',
                    align: 'center'
                },
                {
                    title:'已受理',
                    dataIndex: 'alertProcessed',
                    align: 'center'
                }
            ]
        },
        {
            title: '故障工单',
            dataIndex: 'fault',
            align: 'center',
            children: [
                {
                    title:'总计',
                    dataIndex: 'faultCount',
                    align: 'center'
                },
                {
                    title:'未受理',
                    dataIndex: 'faultUnprocessed',
                    align: 'center'
                },
                {
                    title:'已受理',
                    dataIndex: 'faultProcessed',
                    align: 'center'
                }
            ]
        },
        {
            title: '巡检工单',
            dataIndex: 'inspection',
            align: 'center',
            children: [
                {
                    title:'总计',
                    dataIndex: 'inspectionCount',
                    align: 'center'
                },
                {
                    title:'未受理',
                    dataIndex: 'inspectionUnprocessed',
                    align: 'center'
                },
                {
                    title:'已受理',
                    dataIndex: 'inspectionProcessed',
                    align: 'center'
                }
            ]
        }
    ])
    const [data, setData] = useState([
        // {
        //     area: '合作区',
        //     alertCount: 20,
        //     alertUnprocessed: 12,
        //     alertProcessed: 8,
        //     faultCount: 100,
        //     faultUnprocessed: 66,
        //     faultProcessed: 34,
        //     inspectionCount: 50,
        //     inspectionUnprocessed: 30,
        //     inspectionProcessed: 20
        // },
        // {
        //     area: '临海新城',
        //     alertCount: 20,
        //     alertUnprocessed: 12,
        //     alertProcessed: 8,
        //     faultCount: 100,
        //     faultUnprocessed: 66,
        //     faultProcessed: 34,
        //     inspectionCount: 50,
        //     inspectionUnprocessed: 30,
        //     inspectionProcessed: 20
        // },
        // {
        //     area: '滨海旅游区',
        //     alertCount: 20,
        //     alertUnprocessed: 12,
        //     alertProcessed: 8,
        //     faultCount: 100,
        //     faultUnprocessed: 66,
        //     faultProcessed: 34,
        //     inspectionCount: 50,
        //     inspectionUnprocessed: 30,
        //     inspectionProcessed: 20
        // }
    ])
    // 关闭modal
    const close = () => {
        props.subClick(false, 'NoFilterbg')
    }
    const selectGzltjDetailTime = (params) => {
        setGzltjDetailTime(params)
        getData(params === '近一月' ? 2 : 1)
    }
    const getData = (data) => {
        const params = {
            dateType: data ? data : 2,
            moduleKey: 'workNumDetail',
            dataQueryType: dataQueryType
        }
        Home.getTypeData(params).then(res => {
            let data = []
            let newData = {}
            let typeList = []
            if (res.code === 0 && res.data[0]) {
                data = res.data[0].data
                data.map(item => {
                    typeList.push(item.areaName)
                })
                typeList = React.$util.arrayUnique(typeList)
                typeList.map(item => {
                    data.map(i => {
                        if (i.areaName === item) {
                            newData[i.areaName] = {
                                ...newData[i.areaName],
                                alertCount: i.ticketType === 'alert' ? Number(i.totalNum) : 0,
                                alertUnprocessed: i.ticketType === 'alert' ? i.notAcceptedNum : 0,
                                alertProcessed: i.ticketType === 'alert' ? Number(i.totalNum) - i.notAcceptedNum : 0,
                                faultCount: i.ticketType === 'fault' ? Number(i.totalNum) : 0,
                                faultUnprocessed: i.ticketType === 'fault' ? i.notAcceptedNum : 0,
                                faultProcessed: i.ticketType === 'fault' ? Number(i.totalNum) - i.notAcceptedNum : 0,
                                inspectionCount: i.ticketType === 'inspection' ? Number(i.totalNum) : 0,
                                inspectionUnprocessed: i.ticketType === 'inspection' ? i.notAcceptedNum : 0,
                                inspectionProcessed: i.ticketType === 'inspection' ? Number(i.totalNum) - i.notAcceptedNum : 0
                            }
                        }
                    })
                })
                const list = []
                for (const key in newData) {
                    list.push({
                        area: key,
                        ...newData[key]
                    })
                }
                setData(list)
            }
        })
    }
    useEffect(() => {
        switch (props.isShowAlertType) {
            case 'classification':
                setDataQueryType(1)
                break;
            case 'communication':
                setDataQueryType(2)
                break;
            case 'waterAffairs':
                setDataQueryType(3)
                break;
            default:
                break;
        }
    }, [])
    useEffect(() => {
        getData()
    }, [dataQueryType])
    return (
        <div className="home-table">
            <a onClick={()=>close()} className="popupClose"></a>
            <Row  style={{transform: 'translateY(20%)'}}>
                <Col span={24} style={{textAlign: 'center'}}>
                    <span style={{fontSize: '20px',color: 'rgb(32, 194, 248)'}}>工作量详情</span>
                    <div className="gzl_detail">
                        <span>{gzltjDetailTime}</span>
                        <div className="gzl_detail_box">
                            <p onClick={() => selectGzltjDetailTime('近一周')}><a>近一周</a></p>
                            <p onClick={() => selectGzltjDetailTime('近一月')}><a>近一月</a></p>
                        </div>
                    </div>
                </Col>
                <Col span={15}  style={{margin: '0 auto'}}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        style={{width: '750px'}}
                        bordered
                        size="small"
                    />
                </Col>
            </Row>
        </div>
    )
}
export default TableModal